import React from 'react';
import {TextField, MenuItem, Grid, Typography, Paper} from 'material-ui';
import {SelectMultiple} from '../../../components/fields/field_multi_select';
import DropzoneImageField from '../../../components/fields/field_dropzone_image';
import ImageDetailsCropDialog from './image_details_crop';
import ImageEditMetaDialog from '../../staff/forms/ImageEditMetaDialog';
import {b64toBlob, toDataUrl} from '../../../components/helpers/helpers';

class MetaReviewFields extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            crop: {
                review: {
                    openImageMetaPopup: false,
                    cropResult: null,
                    thumbCropResult: null,
                    imageIndex: 0,
                    imageToCrop: null,
                    imageToView: null,
                    openCropPopup: false,
                    imageMeta: {
                        title: '',
                        alt: '',
                        name: '',
                        description: '',
                        link: '',
                    },
                },
            },
        };
    }

    render() {
        let {
            languages,
            ageGroups,
            allProducts,
            classes,
            authorFullName,
            authorAbbreviatedName,
            quote,
            language,
            ageGroup,
            reviewImage,
            selectedProducts,
            updatePageMetaReviewFullName,
            updatePageMetaReviewProducts,
            updatePageMetaReviewAbbrName,
            updatePageMetaReviewQuote,
            updatePageMetaReviewLanguage,
            updatePageMetaReviewAgeGroup,
            onDeleteReviewImageField,
            onReviewImageMetaUpdate,
            onUpdateReviewImageField,
            selectHasError,
            validateField,
            metaError,
            productHasError,
        } = this.props;

        return (
            <div>
                <Typography
                    variant="caption"
                    className={productHasError}
                    style={{marginBottom: 5}}
                >
                    Products *
                </Typography>
                <SelectMultiple
                    id="products"
                    label={'Select Products'}
                    name="products"
                    onItemsChange={(items) => {
                        updatePageMetaReviewProducts(items);
                    }}
                    selectedItems={selectedProducts}
                    items={allProducts}
                    labelKey={'display_name'}
                    valueKey={'id'}
                />
                {selectHasError(selectedProducts, 'products') ? (
                    <Typography variant="caption" color="error">
                        Please select at least one value!
                    </Typography>
                ) : (
                    <Typography variant="caption">
                        Select Products from the drop-down
                    </Typography>
                )}
                <TextField
                    margin="dense"
                    id="authorFullName"
                    name="authorFullName"
                    label="Author Full Name"
                    value={authorFullName || ''}
                    onChange={(event) => {
                        updatePageMetaReviewFullName(event.target.value);
                        validateField(event.target.value, event.target.name);
                    }}
                    fullWidth
                    error={metaError['authorFullName'] || !authorFullName}
                    helperText={
                        metaError['authorFullName'] || !authorFullName
                            ? 'Please fill in the author name!'
                            : 'Type author name here'
                    }
                />
                <TextField
                    margin="dense"
                    id="authorAbbreviatedName"
                    label="Author Acronym"
                    value={authorAbbreviatedName || ''}
                    onChange={(event) => {
                        updatePageMetaReviewAbbrName(event.target.value);
                    }}
                    fullWidth
                />
                <TextField
                    margin="dense"
                    id="quote"
                    name="quote"
                    label="Pull Quote"
                    value={quote || ''}
                    onChange={(event) => {
                        updatePageMetaReviewQuote(event.target.value);
                        validateField(event.target.value, event.target.name);
                    }}
                    fullWidth
                    multiline
                    error={metaError['quote'] || !quote}
                    helperText={
                        metaError['quote'] || !quote
                            ? 'Please fill in the quote!'
                            : 'Type quote here'
                    }
                />
                <div id="reviewMeta">
                    <Grid
                        container
                        className={classes.reviewSelects}
                        id="langAndAgeSelects"
                    >
                        <Grid item xs={12} md={6}>
                            <TextField
                                select
                                name="languages"
                                label="Language"
                                value={language || 0}
                                fullWidth
                                onChange={(event) => {
                                    updatePageMetaReviewLanguage(
                                        event.target.value
                                    );
                                    validateField(
                                        event.target.value,
                                        event.target.name
                                    );
                                }}
                                error={metaError['languages'] || !language}
                                helperText={
                                    metaError['languages'] || !language
                                        ? 'Please select a value!'
                                        : 'Select language in the drop-down here'
                                }
                            >
                                <MenuItem
                                    key={0}
                                    value={0}
                                    disabled
                                    className={classes.selectMenuItem}
                                >
                                    <span
                                        className={classes.selectMenuItemSpan}
                                    >
                                        Select language here
                                    </span>
                                </MenuItem>
                                {languages.map((option) => (
                                    <MenuItem
                                        key={option.id}
                                        value={option.id}
                                        className={classes.selectMenuItem}
                                    >
                                        {option.name}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                select
                                name="age-groups"
                                label="Age group"
                                value={ageGroup || 0}
                                fullWidth
                                onChange={(event) => {
                                    updatePageMetaReviewAgeGroup(
                                        event.target.value
                                    );
                                    validateField(
                                        event.target.value,
                                        event.target.name
                                    );
                                }}
                                error={metaError['age-groups'] || !ageGroup}
                                helperText={
                                    metaError['age-groups'] || !ageGroup
                                        ? 'Please select a value!'
                                        : 'Select age group in the drop-down here'
                                }
                            >
                                <MenuItem
                                    key={0}
                                    value={0}
                                    disabled
                                    className={classes.selectMenuItem}
                                >
                                    <span
                                        className={classes.selectMenuItemSpan}
                                    >
                                        Select age group here
                                    </span>
                                </MenuItem>
                                {ageGroups.map((option) => (
                                    <MenuItem
                                        key={option.id}
                                        value={option.id}
                                        className={classes.selectMenuItem}
                                    >
                                        {option.display_name}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography
                                variant="subheading"
                                className={classes.imageUploadSubheadingText}
                            >
                                Review Image
                            </Typography>
                            <Paper elevation={1} style={{padding: 10}}>
                                <DropzoneImageField
                                    multiple={false}
                                    images={reviewImage}
                                    onImageDelete={(image, index) => {
                                        onDeleteReviewImageField(image, index);
                                    }}
                                    onImageClick={(image) => {
                                        if (image.new) {
                                            this.updateReviewStateImageToCropAndProcessIt(
                                                image
                                            );
                                        } else {
                                            this.updateReviewStateImageToView(
                                                image
                                            );
                                        }
                                    }}
                                    onImagesDrop={(image) => {
                                        onUpdateReviewImageField(image);
                                    }}
                                />
                                {reviewImage &&
                                    reviewImage.new &&
                                    !reviewImage.deleted && (
                                        <h4 className="errMsg">
                                            Once you have selected a Review
                                            Image please click on it in order to
                                            CROP it. Crop is mandatory!
                                        </h4>
                                    )}
                            </Paper>
                        </Grid>
                    </Grid>
                </div>

                <ImageDetailsCropDialog
                    open={this.state.crop.review.openCropPopup}
                    cropResult={this.state.crop.review.cropResult}
                    thumbCropResult={this.state.crop.review.thumbCropResult}
                    imageToCrop={this.state.crop.review.imageToCrop}
                    imageRatios={this.props.imageRatios}
                    imageMeta={this.state.crop.review.imageMeta}
                    setAltField={(alt) => this.setStateReviewAltField(alt)}
                    setTitleField={(title) =>
                        this.setStateReviewTitleField(title)
                    }
                    setDescriptionField={(description) =>
                        this.setStateReviewDescriptionField(description)
                    }
                    setLinkField={(link) => this.setLinkField(link)}
                    setNameField={(name) => this.setStateReviewNameField(name)}
                    setCropResult={(cropResult) =>
                        this.updateReviewStateCropResult(cropResult)
                    }
                    setThumbCropResult={(thumbCropResult) =>
                        this.updateReviewStateCropThumbResult(thumbCropResult)
                    }
                    handleSubmit={() => this.submitReviewCropResult()}
                    handleClose={() => {
                        this.clearReviewCropStateAfterPopupClose();
                    }}
                    isHero={false}
                    displayAllRatios={false}
                />

                <ImageEditMetaDialog
                    open={this.state.crop.review.openImageMetaPopup}
                    classes={classes}
                    imageMeta={this.state.crop.review.imageMeta}
                    image={this.state.crop.review.imageToView}
                    setAltField={(alt) => this.setStateReviewAltField(alt)}
                    setTitleField={(title) =>
                        this.setStateReviewTitleField(title)
                    }
                    setDescriptionField={(description) =>
                        this.setStateReviewDescriptionField(description)
                    }
                    setLinkField={(link) => this.setLinkField(link)}
                    setNameField={(name) => this.setStateReviewNameField(name)}
                    handleSubmit={() => {
                        onReviewImageMetaUpdate(
                            this.state.crop.review.imageMeta
                        );
                        this.clearReviewCropStateAfterPopupClose();
                    }}
                    handleCancel={() => {
                        this.clearReviewCropStateAfterPopupClose();
                    }}
                />
            </div>
        );
    }

    clearReviewCropStateAfterPopupClose() {
        this.setState({
            ...this.state,
            crop: {
                review: {
                    ...this.state.crop.review,
                    cropResult: null,
                    thumbCropResult: null,
                    openImageMetaPopup: false,
                    imageToCrop: null,
                    openCropPopup: false,
                    imageMeta: {
                        title: '',
                        alt: '',
                        name: '',
                        description: '',
                        link: '',
                    },
                },
            },
        });
    }

    clearReviewCropStateAfterPopupSubmit() {
        this.setState({
            ...this.state,
            crop: {
                review: {
                    ...this.state.crop.review,
                    openImageMetaPopup: false,
                    imageToCrop: null,
                    openCropPopup: false,
                    imageMeta: {
                        title: '',
                        alt: '',
                        name: '',
                        description: '',
                        link: '',
                    },
                },
            },
        });
    }

    updateReviewStateCropResult(cropResult) {
        this.setState({
            ...this.state,
            crop: {
                review: {
                    ...this.state.crop.review,
                    cropResult,
                },
            },
        });
    }

    updateReviewStateCropThumbResult(cropResult) {
        this.setState({
            ...this.state,
            crop: {
                review: {
                    ...this.state.crop.review,
                    thumbCropResult: cropResult,
                },
            },
        });
    }

    updateReviewStateImageToView(image) {
        const {title, alt, name, description, link} = image;
        this.setState({
            ...this.state,
            crop: {
                review: {
                    ...this.state.crop.review,
                    openCropPopup: false,
                    openImageMetaPopup: true,
                    imageToCrop: null,
                    imageToView: image,
                    imageMeta: {
                        title,
                        alt,
                        name,
                        description,
                        link,
                    },
                },
            },
        });
    }

    updateReviewStateImageToCrop(image) {
        const {title, alt, name, description, link} = image;
        this.setState({
            ...this.state,
            crop: {
                review: {
                    ...this.state.crop.review,
                    imageToCrop: image,
                    openCropPopup: true,
                    imageMeta: {
                        title,
                        alt,
                        name,
                        description,
                        link,
                    },
                },
            },
        });
    }

    setStateReviewAltField(alt) {
        this.setState({
            ...this.state,
            crop: {
                review: {
                    ...this.state.crop.review,
                    imageMeta: {
                        ...this.state.crop.review.imageMeta,
                        alt,
                    },
                },
            },
        });
    }

    setStateReviewTitleField(title) {
        this.setState({
            ...this.state,
            crop: {
                review: {
                    ...this.state.crop.review,
                    imageMeta: {
                        ...this.state.crop.review.imageMeta,
                        title,
                    },
                },
            },
        });
    }

    setStateReviewDescriptionField(description) {
        this.setState({
            ...this.state,
            crop: {
                review: {
                    ...this.state.crop.review,
                    imageMeta: {
                        ...this.state.crop.review.imageMeta,
                        description,
                    },
                },
            },
        });
    }

    setLinkField(link) {
        this.setState({
            ...this.state,
            crop: {
                review: {
                    ...this.state.crop.review,
                    imageMeta: {
                        ...this.state.crop.review.imageMeta,
                        link,
                    },
                },
            },
        });
    }

    setStateReviewNameField(name) {
        this.setState({
            ...this.state,
            crop: {
                review: {
                    ...this.state.crop.review,
                    imageMeta: {
                        ...this.state.crop.review.imageMeta,
                        name,
                    },
                },
            },
        });
    }

    updateReviewStateImageToCropAndProcessIt(image) {
        this.updateReviewStateImageToCrop(image);
        let croppedImage = this.props.reviewImage.croppedImage;
        if (croppedImage) {
            toDataUrl(croppedImage, (cropResult) => {
                this.updateReviewStateCropResult(cropResult);
            });
        }
        let croppedImageThumb = this.props.reviewImage.croppedImageThumb;
        if (croppedImageThumb) {
            toDataUrl(croppedImageThumb, (cropResult) => {
                this.updateReviewStateCropThumbResult(cropResult);
            });
        }
    }

    submitReviewCropResult() {
        if (this.state.crop.review.cropResult) {
            let imageObject = b64toBlob(this.state.crop.review.cropResult);
            const imageUrlBlob = URL.createObjectURL(imageObject);
            this.props.onCropReviewImage(
                imageObject,
                imageUrlBlob,
                imageObject,
                this.state.crop.review.imageIndex
            );
        }
        if (this.state.crop.review.thumbCropResult) {
            let thumbImageObject = b64toBlob(
                this.state.crop.review.thumbCropResult
            );
            const imageThumbUrlBlob = URL.createObjectURL(thumbImageObject);
            this.props.onCropReviewThumbImage(
                thumbImageObject,
                imageThumbUrlBlob,
                thumbImageObject,
                this.state.crop.review.imageIndex
            );
        }
        this.props.onReviewImageMetaUpdate(
            this.state.crop.review.imageMeta,
            this.state.crop.review.imageIndex
        );
        this.clearReviewCropStateAfterPopupSubmit();
    }
}

export default MetaReviewFields;



// WEBPACK FOOTER //
// ./src/containers/builder/form/meta_review_fields.js